export const NewOrderScenario = {
  create: "create",
  duplicate: "duplicate",
  extend: "extend",
  promote: "promote",
} as const;

export type TNewOrderScenario =
  (typeof NewOrderScenario)[keyof typeof NewOrderScenario];
